module.exports = __webpack_public_path__ + "static/telegram-logo-png-open-2000-ebde6db9f4a2fc50afd71b417459eced.png";